import { cva } from '../tokens/variants';

export const textVariants = cva('font-inter', {
  variants: {
    size: {
      xs: 'text-xs leading-relaxed',
      sm: 'text-sm leading-relaxed',
      md: 'text-base leading-relaxed',
      lg: 'text-lg leading-relaxed',
      caption: 'text-xs uppercase tracking-wider',
    },
    weight: {
      regular: 'font-normal',
      medium: 'font-medium',
      semibold: 'font-semibold',
      bold: 'font-bold',
    },
    color: {
      default: 'text-[var(--tk-surface-fg)]',
      muted: 'text-[var(--tk-surface-fg-muted)]',
      subtle: 'text-[var(--tk-surface-fg-subtle)]',
      brand: 'text-[var(--tk-brand-fg-on-subtle)]',
      danger: 'text-[var(--tk-danger-fg-on-subtle)]',
      success: 'text-[var(--tk-success-fg-on-subtle)]',
      warning: 'text-[var(--tk-warning-fg-on-subtle)]',
      info: 'text-[var(--tk-info-fg-on-subtle)]',
      inverse: 'text-[var(--tk-brand-fg)]',
    },
    align: {
      left: 'text-left',
      center: 'text-center',
      right: 'text-right',
    },
    truncate: {
      true: 'truncate',
      false: '',
    },
  },
  defaultVariants: {
    size: 'md',
    weight: 'regular',
    color: 'default',
    align: 'left',
    truncate: false,
  },
});
